"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheggIdManager = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _logger = _interopRequireDefault(require("./logger"));

var _adobe = require("./adobe");

var _misc = require("./misc");

var _uuid = _interopRequireDefault(require("./uuid"));

var _urls = require("./urls");

var _getSessionConstants = require("./getSessionConstants");

var _onetrust = require("../utils/onetrust");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var jsCookie = require('js-cookie');

var CVID_COOKIE_NAME = 'CVID';
var CSID_COOKIE_NAME = 'CSID';
var CVID_TEST_ENDPOINT = 'https://analytics.test.cheggnet.com/visitor-session-id-service/web/cvid';
var CVID_PROD_ENDPOINT = 'https://analytics.chegg.com/visitor-session-id-service/web/cvid';
var CSID_TEST_ENDPOINT = 'https://analytics.test.cheggnet.com/visitor-session-id-service/web/csid';
var CSID_PROD_ENDPOINT = 'https://analytics.chegg.com/visitor-session-id-service/web/csid';
var ENDPOINT_ERROR_SAMPLE_RATE = 0.01;

var sample = function sample(sampleRate) {
  return Math.random() < sampleRate;
};

var CheggIdManager = /*#__PURE__*/function () {
  function CheggIdManager() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, CheggIdManager);
    (0, _defineProperty2["default"])(this, "isInitialized", void 0);
    (0, _defineProperty2["default"])(this, "env", void 0);
    (0, _defineProperty2["default"])(this, "fetchCvid", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
        var fetchId;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fetchId = /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                    var response;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return (0, _axios["default"])({
                              url: url,
                              method: 'get',
                              withCredentials: true
                            });

                          case 2:
                            response = _context.sent;
                            return _context.abrupt("return", response.data.cvid);

                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function fetchId() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                _context2.prev = 1;
                return _context2.abrupt("return", fetchId());

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](1);

                if (sample(ENDPOINT_ERROR_SAMPLE_RATE)) {
                  _logger["default"].error(new Error("RSW request to ".concat(url, " failed. ").concat(_context2.t0.message)));
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 5]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "determineEnvironment", function () {
      try {
        var url = window.location.href;
        var subdomain = (0, _urls.getSubdomain)(url);

        if (url.includes('cheggnet') || subdomain && subdomain.includes('playground') || (0, _urls.isLocalDomain)(url) || url.includes('playground') || url.includes('outcomesccmdev.wpengine.com')) {
          return 'test';
        } else {
          return 'prod';
        }
      } catch (e) {
        return 'test';
      }
    });
    (0, _defineProperty2["default"])(this, "addCvidQueryParams", function (endpoint) {
      var domainCvid = jsCookie.get(CVID_COOKIE_NAME);
      var domainMcid = (0, _adobe.getAdobeCookie)();

      if (domainCvid && !domainMcid) {
        return "".concat(endpoint, "?domain_cvid=").concat(domainCvid);
      } else if (!domainCvid && domainMcid) {
        return "".concat(endpoint, "?domain_mcid=").concat(domainMcid);
      } else if (domainCvid && domainMcid) {
        return "".concat(endpoint, "?domain_cvid=").concat(domainCvid, "&domain_mcid=").concat(domainMcid);
      }

      return endpoint;
    });
    (0, _defineProperty2["default"])(this, "getFallbackCvid", function () {
      var cookieCvid = null;

      try {
        cookieCvid = jsCookie.get(CVID_COOKIE_NAME);
      } catch (error) {
        _logger["default"].warn(error);
      }

      if (cookieCvid) {
        return cookieCvid;
      } else {
        if ((0, _onetrust.consentGrantedSNC)()) {
          var baseEndpoint = _this.env === 'prod' ? CVID_PROD_ENDPOINT : CVID_TEST_ENDPOINT;
          var endpoint = "".concat(baseEndpoint, "?cfnd=0");

          _this.fetchCvid(endpoint).then(function (fetchedCvid) {
            if (fetchedCvid) {
              (0, _misc.setCookieOnRootDomain)(CVID_COOKIE_NAME, fetchedCvid, {
                expires: 2000
              });
              return fetchedCvid;
            } else {
              return _uuid["default"].get();
            }
          })["catch"](function (e) {
            _logger["default"].error(new Error("Unexpected error fetching cvid ".concat(e.message)));

            var cookieCvid = _uuid["default"].get();

            (0, _misc.setCookieOnRootDomain)(CVID_COOKIE_NAME, cookieCvid, {
              expires: 2000
            });
            return cookieCvid;
          });
        } else {
          return _uuid["default"].get();
        }
      }
    });
    (0, _defineProperty2["default"])(this, "fetchCsid", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(url, cvid, domainCsid) {
        var fetchId;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fetchId = /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                    var _response$data;

                    var response;
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return (0, _axios["default"])({
                              url: url,
                              method: 'post',
                              data: {
                                cvid: cvid,
                                domainCsid: domainCsid,
                                data: {
                                  client_common: (0, _getSessionConstants.getSessionConstants)({
                                    chegg_visitor_id: cvid
                                  })
                                }
                              },
                              withCredentials: true
                            });

                          case 2:
                            response = _context3.sent;
                            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.csid);

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function fetchId() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context4.prev = 1;
                return _context4.abrupt("return", fetchId());

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](1);

                if (sample(ENDPOINT_ERROR_SAMPLE_RATE)) {
                  console.error("RSW request to ".concat(url, " failed all retries. ").concat(_context4.t0.message));
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 5]]);
      }));

      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "addIdsToEvent", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(payload) {
        var cvid, csid, newClientCommon;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.getCvid();

              case 2:
                cvid = _context5.sent;
                _context5.next = 5;
                return _this.getCsid();

              case 5:
                csid = _context5.sent;
                newClientCommon = _objectSpread(_objectSpread({}, payload.extensions.client_common), {}, {
                  chegg_visitor_id: cvid,
                  chegg_session_id: csid
                });
                return _context5.abrupt("return", _objectSpread(_objectSpread({}, payload), {}, {
                  extensions: {
                    client_common: newClientCommon
                  }
                }));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "getCheggIds", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var cvid, csid;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this.getCvid();

            case 2:
              cvid = _context6.sent;
              _context6.next = 5;
              return _this.getCsid();

            case 5:
              csid = _context6.sent;
              return _context6.abrupt("return", {
                chegg_visitor_id: cvid,
                chegg_session_id: csid
              });

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    (0, _defineProperty2["default"])(this, "enrichEventsWithCheggIds", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(events) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.all(events.map(_this.addIdsToEvent)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    }());
    this.isInitialized = this.initializeCheggIds();
  }

  (0, _createClass2["default"])(CheggIdManager, [{
    key: "initializeCheggIds",
    value: function initializeCheggIds() {
      var _this2 = this;

      // console.log("RSW: initializeCheggIds - called");
      if (!(0, _misc.noWindow)()) {
        this.env = this.determineEnvironment();
        return this.initCvid().then(function (cvid) {
          return _this2.initCsid(cvid);
        }).then(function () {
          // console.log("RSW: initializeCheggIds - returning true");
          return Promise.resolve(true);
        });
      } else {
        // console.log("RSW: initializeCheggIds - returning Promise(true)");
        return Promise.resolve(true);
      }
    }
  }, {
    key: "initCvid",
    value: function initCvid() {
      var _this3 = this;

      var baseEndpoint = this.env === 'prod' ? CVID_PROD_ENDPOINT : CVID_TEST_ENDPOINT;
      var endpoint = this.addCvidQueryParams(baseEndpoint);
      return this.fetchCvid(endpoint).then(function (fetchedCvid) {
        if (fetchedCvid) {
          (0, _misc.setCookieOnRootDomain)(CVID_COOKIE_NAME, fetchedCvid, {
            expires: 2000
          });
          return fetchedCvid;
        }

        return _this3.getFallbackCvid();
      })["catch"](function (e) {
        _logger["default"].error(new Error("Unexpected error fetching cvid ".concat(e.message)));

        return _this3.getFallbackCvid();
      });
    }
  }, {
    key: "getCvid",
    value: function getCvid() {
      var _this4 = this;

      // console.log("getCvid()");
      if (!(0, _misc.noWindow)()) {
        // console.log("isInitialized: " + JSON.stringify(this.isInitialized));
        return this.isInitialized.then(function () {
          return _this4.getFallbackCvid();
        });
      } else {
        //server-side: has no CVID
        return Promise.resolve("");
      }
    }
  }, {
    key: "getFallbackCsid",
    value: function getFallbackCsid() {
      var cookieCsid = null;

      try {
        cookieCsid = jsCookie.get(CSID_COOKIE_NAME);
      } catch (error) {
        _logger["default"].warn(error);
      }

      if (!cookieCsid) {
        cookieCsid = String(Date.now());
      } // update expiration whenever cookie is called


      (0, _misc.setCookieOnRootDomain)(CSID_COOKIE_NAME, cookieCsid, {
        expires: (0, _misc.getDateXMinutesFromNow)(30)
      });
      return Number(cookieCsid);
    }
  }, {
    key: "initCsid",
    value: function initCsid(cvid) {
      var _this5 = this;

      var endpoint = this.env === 'prod' ? CSID_PROD_ENDPOINT : CSID_TEST_ENDPOINT;
      var storedCookie = null;

      try {
        storedCookie = jsCookie.get(CSID_COOKIE_NAME);
      } catch (error) {
        _logger["default"].warn(error);
      }

      var domainCsid = storedCookie ? Number(storedCookie) : Date.now();

      if (storedCookie) {
        // if the cookie exists, domainCsid is the cookie
        // we don't need to wait for the value because we know the cookie will be used
        this.fetchCsid(endpoint, cvid, domainCsid);
        return Promise.resolve(domainCsid);
      } else {
        // const fetchedCsid = await this.fetchCsid(endpoint, domainCsid);
        return this.fetchCsid(endpoint, cvid, domainCsid).then(function (fetchedCsid) {
          // If we got the csid successfully from service, set the cookie and return fetched value
          if (fetchedCsid) {
            // address race condition with multiple calls
            storedCookie = jsCookie.get(CSID_COOKIE_NAME);
            var firstCsid = storedCookie ? storedCookie : String(fetchedCsid);
            (0, _misc.setCookieOnRootDomain)(CSID_COOKIE_NAME, firstCsid, {
              expires: (0, _misc.getDateXMinutesFromNow)(30)
            });
            return Number(firstCsid);
          }

          return _this5.getFallbackCsid();
        })["catch"](function (e) {
          _logger["default"].error(new Error("Error encountered when fetching csid ".concat(e)));

          return _this5.getFallbackCsid();
        });
      }
    }
  }, {
    key: "getCsid",
    value: function getCsid() {
      var _this6 = this;

      // console.log("getCvid()");
      if (!(0, _misc.noWindow)()) {
        // console.log("isInitialized: " + JSON.stringify(this.isInitialized));
        return this.isInitialized.then(function () {
          return _this6.getFallbackCsid();
        });
      } else {
        return Promise.resolve(Date.now());
      }
    } // v9

  }]);
  return CheggIdManager;
}();

exports.CheggIdManager = CheggIdManager;